import React from 'react'

function NoTripsyet() {
  // Generate unique IDs to prevent conflicts when multiple instances are rendered
  const uniqueId = React.useMemo(() => Math.random().toString(36).substr(2, 9), []);
  
  return (
    <div>
      <svg
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter={`url(#filter0_dd_${uniqueId})`}>
          <rect
            x="8.5"
            y="8"
            width="56"
            height="56"
            rx="28"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.6119 38.6166L28.5469 34.5416L30.7969 33.7866C31.2052 33.65 31.6535 33.7133 32.0069 33.9583L33.9602 35.3066L38.6585 33.2383L33.7502 27.02L37.7469 26.17L44.2019 31.225L51.0852 28.4816C52.7702 27.81 54.6302 28.9333 54.8185 30.7366V30.7366C54.9452 31.9333 54.2735 33.0733 53.1635 33.5433L40.8252 38.7666C40.5085 38.9 40.1719 38.9733 39.8285 38.9816L32.7385 39.1583C32.2969 39.1733 31.8769 38.97 31.6119 38.6166Z"
            stroke={`url(#paint0_linear_${uniqueId})`}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M49.8943 29C47.4859 24.2683 42.5826 21.02 36.9109 21.02C28.8609 21.02 22.3359 27.5483 22.3359 35.6033C22.3359 43.6567 28.8609 50.1867 36.9109 50.1867C44.9609 50.1867 51.4859 43.6583 51.4859 35.6033C51.4859 35.1683 51.4576 34.7417 51.4209 34.3167"
            stroke={`url(#paint1_linear_${uniqueId})`}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.3681 36.5817C19.2614 38.86 17.5797 41.3883 18.3297 43.155C19.3931 45.7883 25.393 45.8467 31.7314 43.285"
            stroke={`url(#paint2_linear_${uniqueId})`}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <filter
            id={`filter0_dd_${uniqueId}`}
            x="0.499999"
            y="-9.53674e-07"
            width="72"
            height="72"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood
              floodOpacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="-2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result={`effect1_dropShadow_${uniqueId}`}
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="2" dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
            />
            <feBlend
              mode="normal"
              in2={`effect1_dropShadow_${uniqueId}`}
              result={`effect2_dropShadow_${uniqueId}`}
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2={`effect2_dropShadow_${uniqueId}`}
              result="shape"
            />
          </filter>
          <linearGradient
            id={`paint0_linear_${uniqueId}`}
            x1="41.6903"
            y1="26.17"
            x2="41.6903"
            y2="39.1591"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6B349A" />
            <stop offset="1" stopColor="#4C37C3" />
          </linearGradient>
          <linearGradient
            id={`paint1_linear_${uniqueId}`}
            x1="36.9109"
            y1="21.02"
            x2="36.9109"
            y2="50.1867"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6B349A" />
            <stop offset="1" stopColor="#4C37C3" />
          </linearGradient>
          <linearGradient
            id={`paint2_linear_${uniqueId}`}
            x1="24.9419"
            y1="36.5817"
            x2="24.9419"
            y2="45.1688"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6B349A" />
            <stop offset="1" stopColor="#4C37C3" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  )
}

export default NoTripsyet